import { reconstructOptions } from 'containers/SubSidebar/AiImageContent/GenerateTab/Content/AspectRatio/utils'
import * as Styled from './styled'

interface IResizeAspectRatioSelectorProps {
  options: string[]
  // null = nothing selected yet (the flyout opens without a preselection)
  value: string | null
  onChange: (ratio: string) => void
}

// Aspect-ratio rows for the Resize flyout, built dynamically from the model's
// supported ratios (reusing the AI Image `reconstructOptions` icon mapping).
// Rows show only the ratio string (e.g. '1:1') — no orientation names — so
// every row is a uniform single line.
const ResizeAspectRatioSelector = ({
  options,
  value,
  onChange
}: IResizeAspectRatioSelectorProps) => (
  <Styled.OptionList>
    {reconstructOptions(options).map(({ key, icon }) => {
      const isSelected = key === value
      return (
        <Styled.OptionRow
          key={key}
          type="button"
          $isSelected={isSelected}
          onClick={() => onChange(key)}
        >
          <Styled.OptionIconWrap>{icon}</Styled.OptionIconWrap>
          <Styled.OptionLabel>{key}</Styled.OptionLabel>
          {isSelected && <Styled.CheckIcon />}
        </Styled.OptionRow>
      )
    })}
  </Styled.OptionList>
)

export default ResizeAspectRatioSelector
